export default "__VITE_ASSET__e155fe2d__"